import rootSaga from './Sagas';

export default rootSaga;
